<ng-template #documentRequirementContainer let-document="document" let-icon="icon">
    <li data-cy="document-requirement" class="document-requirement"
        [cdkOverlayOrigin] #listItemOrigin="cdkOverlayOrigin"
        >
        <div class="organizing-container">
            <div class="left-elements">
                <div class="icon">
                @switch (icon) {
                    @case ('not-accepted') {
                        <!-- Homemade indicator (vs. material icon) -->
                        <div class="not-accepted" matTooltip="Under review" matTooltipPosition="above"></div>
                    }
                    @case ('accepted') {
                        <mat-icon class="accepted" matTooltip="Reviewed">check_small</mat-icon>
                    }
                    @default {
                        <mat-icon>empty</mat-icon>
                    }
                }
                </div>
                <div class="item-text">
                    <span class="document-title">
                        {{ document?.documentCategory?.name }}
                        @if (document?.timePeriod) {
                        - {{ document?.timePeriod }}
                        }
                    </span>
                    @if(document?.contact) {
                        <span class="contact-name">
                            {{ document?.contact?.first | titlecase }}
                            {{ document?.contact?.last | titlecase }}
                        </span>
                    }
                </div>
            </div>
            <div class="right-elements">  
                <!-- eSignature button -- TODO: Enable for pipeline users? -->
                @if (hasEsignaturePlus() && document?.docusignEnvelope){
                <button data-cy="eSignature-doc-requirement-button"
                    mat-icon-button matTooltip="eSignature"
                    matTooltipPosition="above" (click)="handleEsignatureClick($event, document)">
                    <mat-icon class="material-symbols-outlined">signature</mat-icon>
                </button>
                }

                <!-- Delete button -->
                 @if(document?.source === DocumentSource.DocumentRequest) {
                    <button data-cy="delete-doc-requirement-button" mat-icon-button matTooltip="Delete"
                        matTooltipPosition="above" (click)="handleRequirementDelete($event, document)">
                        <mat-icon>delete_outlined</mat-icon>
                    </button>
                }
            </div>
        </div>
        <!-- eSignature tooltip -->
        <ng-template
            [cdkConnectedOverlay]
            [cdkConnectedOverlayOrigin]="listItemOrigin"
            [cdkConnectedOverlayOpen]="showDocusignTimestamps === document?.documentCategory?.name"
            [cdkConnectedOverlayPositions]="[
                { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' }
            ]"
            [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
            (overlayOutsideClick)="handleOverlayOutsideClick()" (detach)="handleOverlayClose()">
            <app-process-timestamps-tooltip tooltipTitle="eSignature Status"
                [timestamps]="document?.docusignEnvelope?.events">
            </app-process-timestamps-tooltip>
        </ng-template>
    </li>
</ng-template>

<section data-cy="document-requirements-component" class="document-requirements"
    [class.no-requirements]="!hasRequirements()">
    <!-- Header button -->
    <div class="requirements-title tw-mb-2">
        <div class="tw-w-full tw-flex tw-justify-between tw-mb-2">
            <div class="tw-text-lg tw-font-semibold">Requirements</div>
            <button class="add-document-requirements-button" data-cy="add-document-requirements-button"
                (click)="openDocumentRequirementDialog($event)">
                Add
            </button>
        </div>
        @if (loadingRequirements() && !initialLoading) {
            <div class="fade-transition" [@fadeInOut]>
                <mat-spinner [diameter]="24"></mat-spinner>
            </div>
        } @else {
            <!-- Accepted fraction -->
            <div class="tw-flex tw-justify-between tw-w-full tw-mb-2" [@fadeInOut]>
                @if (acceptedPercentage()) {
                    <div class="accepted-percentage">{{ acceptedPercentage() }}</div>
                }
                @if (!loadingRequirements()) {
                    <div class="accepted-fraction">{{ acceptedFraction() }}</div>
                }
            </div>
        }
    </div>
    @if (loadingRequirements() && initialLoading) {
        <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-my-4 tw-p-6" [@fadeInOut]>
            <mat-spinner [diameter]="42"></mat-spinner>
        </div>
    }
    <!-- List of Document requirements -->
    @if (hasRequirements()) {
        <ul class="tw-max-w-[352px]" [@fadeInOut]>
            <!-- Not yet uploaded -->
            @for (document of notUploaded(); track $index) {
            <ng-container
                *ngTemplateOutlet="documentRequirementContainer; context: { document }"></ng-container>
            }

            <!-- Uploaded but not accepted -->
            @for (document of uploadedButNotAccepted(); track $index) {
            <ng-container
                *ngTemplateOutlet="documentRequirementContainer; context: { document, icon: 'not-accepted' }"></ng-container>
            }

            <!-- Accepted -->
            @for (document of documentRequirements()(deal.id).satisfied; track $index) {
            <ng-container
                *ngTemplateOutlet="documentRequirementContainer; context: { document, icon: 'accepted' }"></ng-container>
            }
        </ul>
    }
</section>